
import {useState,useRef} from "react";
import FilePreview from "../../FilePreview";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CreateOpportunity = ({owner}) => {
  const {university_name,dean_name,department_name} = useParams()
  const navigate=useNavigate()
  const [publisher,setPublisher]=useState("")
  const [publication_type,setPublicationType]=useState("")
  const [name,setName]=useState("")
  const [domain,setDomain]=useState("")
  const [maturity,setMaturity]=useState("")
  const [visibility,setVisibility]=useState("")
  const [collaboration,setCollaboration]=useState("")
  const [summary,setSummary]=useState("")
  const [description,setDescription]=useState("")
  const [file,setFile]=useState(null)
  const fileInputRef = useRef(null);
  const [referenceFiles,setReferenceFiles]=useState([])
  const [loading,setLoading]=useState(false)
 
  const handleSubmit=async(e)=>{
    e.preventDefault()
    const formData=new FormData()
    formData.append("name",name)
    formData.append("domain",domain)
    formData.append("publisher",publisher)
    formData.append("maturity",maturity)
    formData.append("visibility",visibility)
    formData.append("collaboration",collaboration)
    formData.append("summary",summary)
    formData.append("description",description)
    formData.append("publication_type",publication_type)
    formData.append("file",file)
    referenceFiles?.forEach((file) => formData.append('reference_files', file));
    
    try {
      setLoading(true)
        const res = await axios.post(
           owner === 'labhead'
    ? `${BASE_URL}/marketplace/university/opportunities/`
    : `${BASE_URL}/marketplace/researcher/create-opportunity/`,
   formData,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    },
  }
);
if (res && (res.status === 200 || res.status === 201)) 
{
    alert("Opportunity created successfully")
    navigate(owner === 'labhead' ? `/marketplace/${university_name}/${dean_name}/${department_name}/lab/labhead/opportunities/` : "/marketplace/independent_researcher/dashboard/opportunity_hub")
}
    } catch (error) {
      console.log("Error while create opportunity",error)
      toast.error(error.code)
      setLoading(false)
    }finally{
      setLoading(false)
  }
  }
  return (
  <div className="flex justify-center p-6">
  <div className="w-full max-w-4xl bg-white rounded-2xl shadow-sm p-8">
    
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-gray-900">
            Create Opportunity
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Fill in the details below to create a new opportunity
          </p>
        </div>
      </div>
   {/* Title Input */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-medium text-gray-700">
            Name
          </label>
        </div>
        <input
          type="text"
          required
          value={name}
          onChange={(e)=>setName(e.target.value)}
          placeholder="Enter opportunity name"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        />
      </div>

      {/* Domain */}
       <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-medium text-gray-700">
            Domain
          </label>
        </div>
        <input
          type="text"
          required
          value={domain}
          onChange={(e)=>setDomain(e.target.value)}
          placeholder="Enter opportunity domain"
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
        />
      </div>
      {/* First Row: Publish + Type */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <label className="text-sm font-medium text-gray-700">
              Publish As
            </label>
          </div>
          <select
            value={publisher}
            onChange={(e)=>setPublisher(e.target.value)}
            required
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          >
            <option value="">Select Publisher</option>
            <option value="researcher">Researcher/Prof</option>
            <option value="university">University/Lab</option>
            <option value="industry">Company/Partner</option>
          </select>
        </div>
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <label className="text-sm font-medium text-gray-700">
              Maturity
            </label>
          </div>
          <select
            required
            value={maturity}
            onChange={(e)=>setMaturity(e.target.value)}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          >
            <option value="">Select Maturity</option>
            <option value="idea">Idea</option>
            <option value="poc">PoC</option>
            <option value="lab-ready">Lab-ready</option>
            <option value="industry-challenge">Industry Challenge</option>
          </select>
        </div>
       
      </div>

   

    

      {/* Third Row: Visibility + Collaboration */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <label className="text-sm font-medium text-gray-700">
              Visibility
            </label>
          </div>
          <select
            required
            value={visibility}
            onChange={(e)=>setVisibility(e.target.value)}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          >
            <option value="">Select Visibility</option>
            <option value="public">Public</option>
            <option value="private">Private</option>
            <option value="restricted">Internal</option>
          </select>
        </div>

        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <label className="text-sm font-medium text-gray-700">
              Collaboration Needed
            </label>
          </div>
          <select
            required
            value={collaboration}
            onChange={(e)=>setCollaboration(e.target.value)}
            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          >
            <option value="">Select Option</option>
            <option value="co-research">Co-research</option>
            <option value="industry-partner">Industry partner</option>
            <option value="grand|pilot">Grant / Pilot</option>
            <option value="mentorship">Mentorship</option>
          </select>
        </div>
      </div>

      {/* Summary Textarea */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-medium text-gray-700">
            Summary (always visible)
          </label>
        </div>
        <textarea
          required
          value={summary}
          onChange={(e)=>setSummary(e.target.value)}
          placeholder="Enter summary"
          rows={4}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-none transition-all"
        />
      </div>

      {/* Full Details Textarea */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-medium text-gray-700">
            Full details (restricted)
          </label>
        </div>
        <textarea
          required
          value={description}
          onChange={(e)=>setDescription(e.target.value)}
          placeholder="Enter full details"
          rows={4}
          className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 resize-none transition-all"
        />
      </div>

       {/* Project Type */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Publication Type
                            </label>
                        </div>
                        <select
                            name="type"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
                            style={{
                                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 16px center'
                            }}
                            required
                            value={publication_type}
                           onChange={(e) => {
  setPublicationType(e.target.value);
  setFile(null);
  if (fileInputRef.current) fileInputRef.current.value = "";
}}

                        >
                            <option value="">Select type</option>
                            <option value="pdf">PDF</option>
                            <option value="doc">DOC</option>
                            <option value="code">Code</option>
                            <option value="image">Image</option>
                            <option value="video">Video</option>
                            <option value="audio">Audio</option>
                        </select>
                    </div>
   {/* Project Image */}
                    <div>
                        <div className="mt-6 flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700" htmlFor="projectImage">
                                Upload {publication_type?.toUpperCase()} File
                            </label>
                        </div>

                        {
                            file ? <>
                                <FilePreview publication_type={publication_type} file={file} setFile={setFile} />

                            </> : <>
                                <label
                                    htmlFor="projectImage"
                                    className={`border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors cursor-pointer flex flex-col items-center ${publication_type ? "" : "pointer-events-none opacity-50"}`}
                                >
                                    <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
                                        <svg
                                            className="w-5 h-5 text-[#0f6abf]"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                            />
                                        </svg>
                                    </div>

                                    <p className="text-sm text-gray-600">Click to upload publication file</p>
                                    <p className="text-xs text-gray-400 mt-1">JPG, PNG up to 5MB</p>
                                </label>

                                {/* Hidden input */}
                                <input
                                    type="file"
                                    id="projectImage"
                                    name="image"
                                    accept={
                                        publication_type === "pdf"
                                            ? "application/pdf"
                                            : publication_type === "doc"
                                                ? "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                : publication_type === "image"
                                                    ? "image/*"
                                                    : publication_type === "video"
                                                        ? "video/*"
                                                        : publication_type === "audio"
                                                            ? "audio/*"
                                                            : publication_type === "code"
                                                                ? ".js,.py,.java,.cpp,.c,.html,.css,.ts,.jsx,.tsx"
                                                                : "*/*" // fallback: allow all
                                    }
                                    className="hidden"
                                    required
                                    ref={fileInputRef}
                                    onChange={(e) => setFile(e.target.files[0])}
                                />
                            </>
                        }
                    </div>

                      <div>
  <div className="mt-6 flex items-center gap-2 mb-3">
    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
    <label className="text-sm font-semibold text-gray-700" htmlFor="projectImages">
      Any Reference Files
    </label>
  </div>

  <label
    htmlFor="projectImages"
    className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors cursor-pointer flex flex-col items-center"
  >
    {referenceFiles && referenceFiles.length > 0 ? (
      <div className="flex flex-col items-center gap-2">
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
          <svg
            className="w-5 h-5 text-[#0f6abf]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <ul className="text-gray-700 list-disc list-inside">
          {Array.from(referenceFiles).map((file, index) => (
            <li key={index}>{file.name}</li>
          ))}
        </ul>
      </div>
    ) : (
      <>
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
          <svg
            className="w-5 h-5 text-[#0f6abf]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
        <p className="text-sm text-gray-600">Click to upload reference files</p>
        <p className="text-xs text-gray-400 mt-1">JPG, PNG up to 5MB</p>
      </>
    )}

    {/* Hidden input */}
    <input
      type="file"
      id="projectImages"
      name="image"
      accept="*"
      multiple
      className="hidden"
      onChange={(e) => setReferenceFiles(Array.from(e.target.files))}
    />
  </label>
</div>
                       {/* Rerernce  Files */}
      {/* Submit Button */}
        <button
    type="submit"
    className="mt-12 w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
    disabled={loading}
>
    {loading ? (
        <>
            {/* Spinner loader */}
            <svg 
                className="animate-spin h-5 w-5 text-white" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24"
            >
                <circle 
                    className="opacity-25" 
                    cx="12" 
                    cy="12" 
                    r="10" 
                    stroke="currentColor" 
                    strokeWidth="4"
                ></circle>
                <path 
                    className="opacity-75" 
                    fill="currentColor" 
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
            Creating Opportunity...
        </>
    ) : (
        <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
            </svg>
           Create Opportunity
        </>
    )}
</button>
    </form>
  </div>
</div>

  );
};

export default CreateOpportunity;
